"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurCoastalLegacy() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -10% 0px"
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    rootMargin: "0px 0px -10% 0px"
  });
  return <section data-section-id="114139" id="the-gold-standard-in-detailing" className="dark bg-background text-foreground py-24 lg:py-32 overflow-hidden relative">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,var(--color-accent),transparent_50%)] opacity-10 pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={imageRef} className="lg:col-span-5 xl:col-span-5 w-full max-w-md mx-auto lg:max-w-none">
            <div className={`relative overflow-hidden rounded-sm transition-all duration-1000 ease-out border border-white/5 ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <AspectRatio ratio={3 / 4} className="bg-muted">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634081/img/captain_drake_helm.png" alt="Macro detail of a perfectly polished chrome cleat reflecting the sun" className={`object-cover w-full h-full transition-transform duration-[2000ms] ease-out ${isImageVisible ? "scale-100" : "scale-110"}`} />
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-transparent to-transparent" />
              </AspectRatio>
            </div>
          </div>

          {}
          <div ref={contentRef} className={`lg:col-span-7 xl:col-span-6 xl:col-start-7 flex flex-col justify-center transition-all duration-1000 delay-300 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="mb-8">
              <Badge variant="default" className="bg-primary text-primary-foreground hover:bg-primary/90 px-4 py-1.5 text-sm tracking-widest uppercase font-sans rounded-sm">
                Precision
              </Badge>
            </div>

            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-8 leading-[1.1] tracking-tight">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-yellow-200 via-amber-400 to-yellow-200">
                The Gold Standard
              </span>
              <br className="hidden md:block" />
              <span className="text-foreground">in Marine Detailing</span>
            </h2>

            <div className="space-y-6 max-w-2xl">
              <p className="font-sans text-xl md:text-2xl italic text-foreground/90 leading-relaxed font-light">"We don’t just clean boats — we keep them consistently maintained, protected, and ready for every day on the water."</p>
              
              <p className="font-sans text-base md:text-lg text-muted-foreground leading-relaxed">Boat Bathers delivers professional boat detailing services across Chicago’s Lake Michigan marinas. Our process focuses on careful hand washing, thorough cleaning, and protective waxing to maintain your boat’s appearance throughout the season. From hull to cockpit, every surface is treated with attention to detail and consistency, helping preserve your boat and keep it looking its best all summer long.</p>
            </div>
          </div>

        </div>
      </div>
    </section>;
}